/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";

export const StyledSubtotalLink = styled("button")({
  padding: 0,
  border: "none",
  background: "none",
  font: "inherit",
  color: "inherit",
  textAlign: "left",
  cursor: "pointer",
  "&:hover, &:focus-visible": {
    color: "#348be5",
  },
});

export const StyledOrdersSummary = styled("div")({
  padding: "0px 24px 12px 24px",
  fontSize: "14px",
  color: "#515152",
});
